var React = require('react');

function SingleChevronLeft (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0_2_1455)","key":0},React.createElement("path",{"d":"M15.9657 0.342445L5.66809 11.1581C5.39051 11.415 5.33501 11.6718 5.33501 11.9857C5.33501 12.3567 5.39051 12.4994 5.64033 12.7848L16.0212 23.6575C16.4375 24.1142 17.1314 24.1142 17.5756 23.6575L18.3528 22.8584C18.7691 22.4019 18.7691 21.6885 18.3528 21.2318L9.49846 11.9572L18.2695 2.76812C18.6858 2.31153 18.6858 1.5981 18.2695 1.14149L17.4923 0.342445C17.1038 -0.114153 16.4098 -0.114153 15.9657 0.342445Z","fill":"currentColor"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0_2_1455"},React.createElement("rect",{"width":"24","height":"24","fill":"white"})))]);
}

SingleChevronLeft.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = SingleChevronLeft;

SingleChevronLeft.default = SingleChevronLeft;
